import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { ProgressInterceptor } from "./progress-interceptors";
import { ApiErrorInterceptor } from "./api-error-interceptor";

export const httpInterceptorProviders = [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: ProgressInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: ApiErrorInterceptor,
    multi: true,
  },
];
